export default {
  DEFAULT_CHEVRON_COLOR: 'rgb(140, 140, 140)',
  DEFAULT_CHEVRON_WIDTH: '18px',
  DEFAULT_CHEVRON_HEIGHT: '18px',
};
